/* eslint-disable indent */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../Article/ArticleModules/SubHead/SubHead';
import BodyText from '../Article/ArticleModules/BodyText/BodyText';
import Button from '../common/Button';
import { getFileName, isValid, isText, segmentTrackEvent } from '../../utils';
import { SITE_HOST } from '../../consts';
import './lander-pw.scss';

const FeaturedArticle = ({
    data, index, isMobile, hasTopFeatured, featuredStories,
 }) => {
    const {id, category, title, body, authorName, authorUrl, image, imageCredit, articleURL, buttonOverride} = data;
    if (!isValid(articleURL) || !isValid(image)) { return null; }
    const link = (isValid(articleURL)) ? articleURL : null;
    const isTopFeatured = (isValid(featuredStories) && index===0);
    const renderedImage = (isValid(image)) ? <img className={`featured-image col-5 ${!isTopFeatured ? 'col-4-sm' : ''}`} src={image} alt={getFileName(image)}/> : null;
    const buttonText = (isText(buttonOverride)) ? buttonOverride : 'Read More';
    const buttonUrl = link;
    const button = (isValid(buttonText) && isValid(buttonUrl)) ? { text: buttonText, url: buttonUrl } : null;
    const renderedButton = (button !== null) ? <Button button={button} /> : null;
    const findIndexByValue = (array, value) => {
        if (!isValid(array)) {
            return -1;
        }
      return array.findIndex(item => item.data.id === value);
    };
    const featuredIndex = findIndexByValue(featuredStories, id);

    const calcDirection = () => {
        let direction;
        if (!hasTopFeatured) {
            direction = (featuredIndex % 2 === 0) ? 'reverse' : 'forward';
        } else {
            direction = (featuredIndex % 2 === 0) ? 'forward' : 'reverse';
        }
        return direction;
    }

    const flexDirection = calcDirection();

    return (
        <>
        {isTopFeatured ?
        <div className="top-feature-container">
            <div className='image-wrapper col-5'>
                <Fragment>
                    <a href={buttonUrl} data-link-type="cta-link" target="_blank" onClick={() => segmentTrackEvent('featured_article', { label: 'image', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                        {renderedImage}
                    </a>
                    <div className="img-credit-container">
                        <span className="img-credit" dangerouslySetInnerHTML={ { __html: imageCredit } }></span>
                    </div>
                </Fragment>
            </div>

            <div className="text-container col-5 col-4-sm">
                <div className="text-wrapper">
                    <Fragment>
                        {isText(category) && <div className="category">{category}<span> / {authorName}</span></div>}
                        {(isText(title)) && 
                            <a className="sub-head-link" href={buttonUrl} data-link-type="cta-link" target="_blank" onClick={() => segmentTrackEvent('featured_article', { label: 'header', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                                <SubHead className="sub-head" data={title}/>
                            </a>
                        }
                        {(isText(body))
                            && <BodyText className="body-text" data={body}/>
                        }
                        <div className="button-wrapper" onClick={() => segmentTrackEvent('featured_article', { label: 'read_more', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                        {renderedButton}
                        </div>
                    </Fragment>
                </div>
            </div>
        </div>
        :
        <div className="secondary-feature">
        <div className={`feature-container ${flexDirection} col-12`}>
            <div className='image-wrapper col-5 col-4-sm'>
                <Fragment>
                    <a href={buttonUrl} data-link-type="cta-link" target="_blank" onClick={() => segmentTrackEvent('featured_article', { label: 'image', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                        {renderedImage}
                    </a>
                    <div className="img-credit-container">
                        <span className="img-credit" dangerouslySetInnerHTML={ { __html: imageCredit } }></span>
                    </div>
                </Fragment>
            </div>

            <div className="text-container col-5 col-4-sm">
                <div className="text-wrapper">
                    <Fragment>
                        {isText(category) && <div className="category">{category}<span> / {authorName}</span></div>}
                        {(isText(title)) && 
                            <a className="sub-head-link" href={buttonUrl} data-link-type="cta-link" target="_blank" onClick={() => segmentTrackEvent('featured_article', { label: 'header', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                                <SubHead className="sub-head" data={title}/>
                            </a>
                        }
                        {(isText(body))
                            && <BodyText className="body-text" data={body}/>
                        }
                        <div className="button-wrapper" onClick={() => segmentTrackEvent('featured_article', { label: 'read_more', action: 'click', category: 'featured_article', destinationUrl: buttonUrl})}>
                        {renderedButton}
                        </div>
                    </Fragment>
                </div>
            </div>
        </div>
        </div>
        }
        </>
    );
};

FeaturedArticle.propTypes = {
    data: PropTypes.object,
    isMobile: PropTypes.boolean,
  };

export default FeaturedArticle;
